export enum WorkflowStageStatusEnum {
  InProgress = 1,
  Idled = 2,
  Completed = 3,
  Cancelled = 4,
  Reassigned = 5,
  Queued = 6
}

export const WorkflowStageStatusOptions = [
{ id: 1, label: 'In Progress' },
{ id: 2, label: 'Idled' },
{ id: 3, label: 'Completed' },
{ id: 4, label: 'Cancelled' },
{ id: 5, label: 'Reassigned' },
{ id: 6, label: 'Queued' }
];
